<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline"
          primary-title
        >
          Playtest data
        </v-card-title>

        <v-card-text>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="localItem.date"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="localItem.date"
                label="Picker in menu"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="localItem.date"
              :first-day-of-week="1"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(localItem.date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="close"
          >
            cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="save"
          >
            save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    item: Object || null,
  },
  data () {
    return {
      dialog: false,
      menu: false,
      localItem: { ...this.item }
    }
  },
  watch: {
    dialog (val) {
      val || this.close();
    },
    item (val) {
      this.localItem = { ...val }
    }
  },
  mounted () {
    this.dialog = true;
  },
  methods: {
    close () {
      this.dialog = false;
      this.$nextTick(() => {
        this.$emit('close');
      });
    },
    save () {

      if (this.localItem.id) {
        this.$emit('update', this.localItem);
      } else {
        this.$emit('create', this.localItem);
      }

      this.$nextTick(() => {
        this.$emit('close');
      })
    }
  }
}
</script>